<div class="language-selector">
  <button
    class="language-selector__trigger"
    type="button"
    (click)="toggle($event)"
    [attr.aria-label]="'header.language.selector' | translate: { language: (current().label) }"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
  >
    <img
      class="language-selector__flag"
      [src]="'/icons/flags/' + current().flag"
      alt=""
      width="16"
      height="16"
    />
    <span class="language-selector__label">{{ current().label }}</span>
    <img
      class="language-selector__chevron"
      [class.language-selector__chevron--open]="isOpen()"
      src="/icons/flags/chevron-down.png"
      alt=""
      width="16"
      height="16"
    />
  </button>

  <div
    #dropdown
    class="language-selector__dropdown"
    *ngIf="isOpen()"
    role="listbox"
    [attr.aria-label]="'header.language.selector' | translate: { language: (current().label) }"
  >
    <div class="language-selector__option language-selector__option--current" role="option" aria-selected="true">
      <img
        class="language-selector__flag"
        [src]="'/icons/flags/' + current().flag"
        alt=""
        width="16"
        height="16"
      />
      <span class="language-selector__label">{{ current().label }}</span>
      <img
        class="language-selector__chevron"
        src="/icons/flags/chevron-up.png"
        alt=""
        width="16"
        height="16"
      />
    </div>

    <button
      class="language-selector__option language-selector__option--alternative"
      type="button"
      role="option"
      aria-selected="false"
      (click)="select(alternative().code, $event)"
      [attr.aria-label]="'header.language.changeTo' | translate: { language: alternative().label }"
    >
      <img
        class="language-selector__flag"
        [src]="'/icons/flags/' + alternative().flag"
        alt=""
        width="16"
        height="16"
      />
      <span class="language-selector__label">{{ alternative().label }}</span>
    </button>
  </div>
</div>
